import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/client";

/**
 * Hook to fetch subscription status
 *
 * Returns the current plan and subscription details for the tenant.
 * Subscription will be null for free tier users.
 */
export function useSubscription() {
  return useQuery({
    queryKey: ["billing", "subscription"],
    queryFn: () => api.billing.getSubscription(),
    staleTime: 30_000,
  });
}
